// **************** common import *******************
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../../utils/redirections";
import CommonHeader from "../../../components/common-header";
// ********************* common function
import { capitalizeFirstLetter } from "../../../utils/redirections";

// *****************************
import Table from "../../../components/table/table";
import { toast} from "react-toastify";

// ******************************** API
import { FetchNotesErrorListByError } from "../../../redux/slices/noteserror.slice";
import { RemoveNotesAPI,DeleteMultiplenotesAPI } from "../../../api/delete";


// INCON
import EditIcon from "../../../assets/icons/edit.png";
import DeleteIcon from "../../../assets/icons/trash.png";
import { FiFileText } from "react-icons/fi";

//edit modal
import {NoteDetailsUpdatePopup} from "./notes_update_popup"

//delete modal
import { ConfirmPopup } from "../../../components/model-popup/confirmation-popup";
import { CustomButton } from "../../../components/buttons/button";
import { WordTitle } from "../../../utils/commonFunction";

// interface 
import { ChildProps } from "../../../utils/types/interFace";
import { getFacilitiesDetails } from "../../../api/list";
import { ReExactNotesAPI } from "../../../api/update";
import { IoReloadOutline } from "react-icons/io5";

const Index = ({filteredAccess}:ChildProps) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(true);
  const userAccess = filteredAccess.length !== 0 ? filteredAccess[0] : {}
  const NotesErrorData = useSelector(
    (state: any) => state?.NotesErrorList?.NotesErrorList || {}
  );


  // search
  const [showSearch, setShowSearch] = useState("");
  const [search, setSearch] = useState<string>("");
  const handleSearch = useCallback(debounce(setSearch, 500), []);

  // sort
  const [sort, setSort] = useState<string>("created_at");
  const [sortDir, setSortDir] = useState<string>("desc");

  const [limit, ] = useState<number>(15);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [totalRecord, setTotalRecord] = useState<number>(0);

  // editview
  const [ViewDetails, setViewDetails] = useState<any>({});
  const [showModal, setShowModal] = useState<boolean>(false);

  // delete
  const [showDeleteModel, setShowDeleteModel] = useState<boolean>(false);
  const [showReprocessModel, setShowReprocessModel] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [multiDelete, setMultiDelete] = useState<any>(false);

  //facilities
  const [facList, setFacList] = useState([])

  // handle the loading the data
  const handleNotesErrorData = (param:any = {}) => {
    const apiParam:any = {page:page,
      limit:limit,
      search_value:search,
      sort_by:sort,
      error:'Header not found',
      sort_dir:sortDir}
    if ('page' in param){
      apiParam['page'] = param['page']
      setPage(param['page'])
    } 
    if ('sort' in param) {
      apiParam['sort_by'] = param['sort'];
      apiParam['sort_dir'] = param['sortDir'];
      apiParam['page'] = 1
      setSort(param['sort'])
      setSortDir(param['sortDir'])
      setPage(1)
    } 
    if ('search' in param) {
      apiParam['search_value'] = param['search'];
      apiParam['page'] = 1
      setPage(1)
    }
    if (apiParam['page'] === 1){
      setLoader(true)
      setSelectedRows([]);
    }
    dispatch(
      FetchNotesErrorListByError(apiParam)
    ).then((res: any) => {
      setTotalPage(res?.payload?.total_pages);
      setTotalRecord(res?.payload?.total_count);
      setLoader(false);
    });
  };

  const handleNextPage = () => {
    handleNotesErrorData({'page':page + 1});
  };

  const afterChangeNotesErrorList = () => {
    handleNotesErrorData({'page':1});
  };

  const handleDelete = async () => {
    setButtonLoader(true);
    await RemoveNotesAPI(ViewDetails?.id).then((res: any) => {
      setShowDeleteModel(false);
      if (res?.result?.success) {
        afterChangeNotesErrorList();
        setMultiDelete(false)
        setViewDetails({});
        toast.success(res?.result?.message);
      } else {
        toast.error(res?.message || "User delete failed");
      }
      setButtonLoader(false);
    });
  };

  const handleMultiDelete = async () => {
      setButtonLoader(true);
      const selectedIds = selectedRows.map((row: any) => row?.id);
      const notes_list = { list_notes_id: selectedIds };
      await DeleteMultiplenotesAPI(notes_list).then(async (res: any) => {
        setShowDeleteModel(false);
        if (res?.success) {
          setViewDetails({});
          setMultiDelete(false);
          setSelectedRows([]);
          afterChangeNotesErrorList()
          toast.success(res?.message);
        } else {
          toast.error(res?.message || res?.detail?.message || "Users delete failed");
        }
        setButtonLoader(false);
      });
    };

  const handleReprocess = async () => {
      setButtonLoader(true);
      const selectedIds = [ViewDetails?.id];
      const notes_list = { list_notes_id: selectedIds };
      await ReExactNotesAPI(notes_list).then(async (res: any) => {
        setShowDeleteModel(false);
        if (res?.success) {
          setViewDetails({});
          setMultiDelete(false);
          setShowReprocessModel(false)
          setSelectedRows([]);
          afterChangeNotesErrorList()
          toast.success(res?.message ||res?.detail?.message || "Reprocess successfully");
        } else {
          toast.error(res?.message || res?.detail?.message || "Reprocess failed");
        }
        setButtonLoader(false);
      });
    };

  const showCheckboxCondition = (row:any)=>{
     return row.status === 'Removed' ? false : true
  }


  const redirectNotesPage = (row:any)=>{
    window.open(`/notes/${row?.id}`, '_blank');
  }

  const handleClose = () => {
    setShowModal(false);
    setViewDetails({});
    setMultiDelete(false);
    setSelectedRows([]);
  };


  /**
       * @function handleFaclities
       * @returns
       * @description handle faclities
       * */
    const handleFaclities = async () => {
      try {
        const result = await getFacilitiesDetails();
        if (result?.result) {
          setFacList(result?.result?.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

  
  useEffect(() => {
     handleNotesErrorData({'search':search});
  }, [search]);

  useEffect(() => {
      handleSearch(showSearch);
    }, [showSearch]);


  useEffect(() => {
      handleFaclities();
    }, []);

  // status colour
  const getStatusClass = (status: string): string => {
    const statusValue = status?.toLowerCase() || ""
    switch (statusValue) {
      case "pending":
      case "re-extract":
        return "bg-purple-100 border-purple-500 text-purple-800";
      case "removed":
        return "bg-yellow-100 border-yellow-500 text-yellow-800";
      case "completed":
        return "bg-green-100 border-green-500 text-green-800";
      case "updated":
        return "bg-blue-100 border-blue-500 text-blue-800";
      case "error":
        return "bg-red-100 border-red-500 text-red-800";
      default:
        return "bg-gray-100 border-gray-500 text-gray-800 ";
    }
  };

  interface StatusCellProps {
    status?: string;
  }

  const StatusCell: React.FC<StatusCellProps> = ({ status }) => {
    return (
      <div
        className={`max-w-[500px] truncate cursor-default px-1.5 py-1 rounded-lg text-sm text-center font-medium border ${getStatusClass(
          status || ""
        )}`}
      >
        {status || "Unknown"}
      </div>
    );
  };

  return (
    <div className="w-full p-[10px] pl-[2px] pr-[2px]">
      <div className="pt-[16px]  pl-[2px] pr-[2px] bg-white rounded-[12px]">
        <CommonHeader
          heading="No Header"
          description="Our system is unable to retrieve the Notes' basic information (the header is missing or uninterpretable). Please update the note header and eFax the note again."
          note="Updated records will be processed automatically during the next update cycle."
          totalCount={totalRecord}
          countForText="Results"
          setShowSearch={setShowSearch}
          showSearch={showSearch}
          search
        />
        <Table
          loading={loader}
          data={NotesErrorData}
          showCheckbox={userAccess.delete_access}
          tableScroll={"100%"}
          sort={true}
          showCheckboxCondition = {showCheckboxCondition}
          setSelectedRows={setSelectedRows}
          MultiDeletedFucn={() => {
            setMultiDelete(true);
            setTimeout(() => {
              setShowDeleteModel(true);
            }, 10);
          }}
          selectedRows={selectedRows}
          Clickable={true}
          rowClick={(row: any) => {
            redirectNotesPage(row)
          }}
          hasNextPage={page < totalPage}
          NextPageData={handleNextPage}
          columns={[
            "Patient",
            "DOB",
            "Gender",
            "Sender",
            "Location",
            "DOS",
            "Status",
            "Action",
          ]}
          sortTitleKeys={{
            Patient: "patient_last_name",
            Sender: "sender_name",
            Location: "location",
            DOS: "encounter_date",
            Gender: "gender",
            Status: "status",
          }}
          handleSortfunc={(key: any, value: any) => {
            handleNotesErrorData({'sort':key,'sortDir':value})
          }}
          scopedSlots={{
            Patient: ({ row }: any) => (
              <td title={`${row?.patient_last_name || ""} ${row?.patient_first_name || ""}`}>
                {row?.patient_detail?.patient_id ? (
                  <a
                    href={`/patient-lookup/${row?.patient_detail?.patient_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-blue-500"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div className="max-w-[200px] truncate cursor-pointer">
                      {![null, ""].includes(row.patient_last_name) &&
                        ![null, ""].includes(row.patient_first_name)
                        ? `${WordTitle(row.patient_last_name)}, ${WordTitle(row.patient_first_name)}`
                        : WordTitle(row.patient_last_name || row.patient_first_name||"")}
                    </div>
                  </a>
                ) : (
                  <div className="max-w-[200px] truncate cursor-pointer">
                    {![null, ""].includes(row.patient_last_name) &&
                      ![null, ""].includes(row.patient_first_name)
                      ? `${WordTitle(row.patient_last_name)}, ${WordTitle(row.patient_first_name)}`
                      : WordTitle(row.patient_last_name || row.patient_first_name||"")}
                  </div>
                )}
              </td>
            ),
            Sender: ({ row }: any) => (
              <td title={row?.sender_name || ""}>
                <div className=" max-w-[200px] truncate cursor-pointer">
                  {WordTitle(row?.sender_name || "")}
                </div>
              </td>
            ),
            Location: ({ row }: any) => (
              <td title={row?.location || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {WordTitle(row?.location || "")}
                </div>
              </td>
            ),
            DOS: ({ row }: any) => (
              <td title={row?.encounter_date || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {row?.encounter_date || ""}
                </div>
              </td>
            ),
            DOB: ({ row }: any) => (
              <td title={row?.DOB || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {row?.DOB || ""}
                </div>
              </td>
            ),
            Gender: ({ row }: any) => (
              <td title={row?.gender || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {row?.gender ? WordTitle(row?.gender) : ''}
                </div>
              </td>
            ),
            Status: ({ row }: any) => (
              <td>
                <StatusCell status={capitalizeFirstLetter(row.status)} />
              </td>
            ),
            Action: ({ row }: any) => {
              const isRemovedOrCompleted = row.status ? (row.status.toLowerCase() === "removed" || row.status.toLowerCase() === "completed"):'';
              return (
                <td>
                  <div className="flex gap-[16px] items-center justify-center pr-[4px]">
                    { !isRemovedOrCompleted &&
                      userAccess.update_access && !["re-extract"].includes(row.status.toLowerCase()) &&
                      <img
                        src={EditIcon}
                        alt="Edit"
                        className="cursor-pointer w-[18px] h-[18px]"
                        onClick={(e) => {
                          e.stopPropagation(); 
                          setViewDetails(row);
                          setShowModal(true);
                        }}
                      />
                    }
                    { !isRemovedOrCompleted &&
                      userAccess.update_access && !["updated","re-extract"].includes(row.status.toLowerCase()) &&
                      <div className="rounded-lg p-1 bg-gray-200 hover:bg-gray-300 text-[#215564] cursor-pointer"
                        onClick={(e) => {
                        e.stopPropagation(); 
                        setMultiDelete(false)
                        setShowDeleteModel(false);
                        setShowReprocessModel(true);
                        setViewDetails(row);
                      }}
                      title="Reprocess the notes"
                      >
                        <IoReloadOutline
                          fontSize={16} 
                        //  style={{ animation: 'spin 2s linear infinite' }}
                          />
                      </div>
                    }
                     
                     {
                      !isRemovedOrCompleted 
                      && userAccess.delete_access 
                      && selectedRows.length <= 1 
                      && <img
                        src={DeleteIcon}
                        onClick={(e) => {
                          e.stopPropagation(); 
                          setMultiDelete(false)
                          setShowDeleteModel(true);
                          setShowReprocessModel(false);
                          setViewDetails(row);
                        }}
                        alt="Delete"
                        className="cursor-pointer w-[18px] h-[18px]"
                      />
                     }
                    <a
                      href={`/notes/${row.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="no-underline"
                      onClick={(e) => {
                        e.stopPropagation(); 
                      }}
                    >
                      <FiFileText fontWeight={900} fontSize={22} title="Notes Content" />
                    </a>
                  </div>
                </td>
              );
            },
          }}
        />
      </div>

      <ConfirmPopup showModal={showDeleteModel} icon>
        <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
          Remove Notes?
        </div>
        <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
          You are about to delete{" "}
          <span className="font-semibold">
            {multiDelete
              ? `${selectedRows?.length} notes`
              : `“${![null, ""].includes(ViewDetails?.patient_last_name) &&
              ![null, ""].includes(ViewDetails?.patient_first_name)
              ? `${WordTitle(ViewDetails?.patient_last_name)}, ${WordTitle(ViewDetails?.patient_first_name)}`
              : WordTitle(ViewDetails?.patient_last_name || ViewDetails?.patient_first_name||"")}” notes`}
          </span> {" "}
          Are you sure you want to continue?
        </div>
        <div className="flex justify-center gap-[16px] items-center w-full">
          <CustomButton
            buttonName="No, Keep it"
            primary={false}
            buttonStyle="w-full text-[#1C252D] hover:bg-[#1C252D]/20 text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
            disable={buttonLoader}
            onClick={() => {
              setShowDeleteModel(false);
              setViewDetails({});
            }}
          />
          <CustomButton
            buttonName="Yes, Remove !"
            buttonStyle="w-full text-white bg-[#D41E1E] hover:bg-[#B51C1C] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
            loader={buttonLoader}
            disable={buttonLoader}
            loaderStyle="w-full bg-[#D41E1E]/80  py-[13px] "
            onClick={() => {
              multiDelete ? handleMultiDelete() : handleDelete();
            }}
          />
        </div>
      </ConfirmPopup>

      <ConfirmPopup showModal={showReprocessModel} icon modalType="warning">
        <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
          Reprocess Notes?
        </div>
        <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
          You are about to reprocess{" "}
          <span className="font-semibold">
            {multiDelete
              ? `${selectedRows?.length} notes`
              : `“${![null, ""].includes(ViewDetails?.patient_last_name) &&
              ![null, ""].includes(ViewDetails?.patient_first_name)
              ? `${WordTitle(ViewDetails?.patient_last_name)}, ${WordTitle(ViewDetails?.patient_first_name)}`
              : WordTitle(ViewDetails?.patient_last_name || ViewDetails?.patient_first_name||"")}” notes`}
          </span> {" "}
          Are you sure you want to continue?
        </div>
        <div className="flex justify-center gap-[16px] items-center w-full">
          <CustomButton
            buttonName="No, Keep it"
            primary={false}
            buttonStyle="w-full text-[#1C252D] hover:bg-[#1C252D]/20 text-[14px] p-[12px] text-[14px] font-semibold leading-[17px] "
            disable={buttonLoader}
            onClick={() => {
              setShowReprocessModel(false);
              setViewDetails({});
            }}
          />
          <CustomButton
            buttonName="Yes, Reprocess !"
            primary={true}
            buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px] "
            loader={buttonLoader}
            disable={buttonLoader}
            loaderStyle="w-full bg-[#1C252D]/80  py-[13px] "
            onClick={handleReprocess}
          />
        </div>
      </ConfirmPopup>

      <NoteDetailsUpdatePopup
        showModal={showModal}
        setShowModal={setShowModal}
        handleClose={handleClose}
        poupDetails={ViewDetails}
        afterChangeNotesList={afterChangeNotesErrorList}
        facList={facList}
      />

    </div>
  );
};

export default Index;